import React from "react";
import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../contants/Endpoints";
import { toast } from "react-toastify";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reuseable/Spinner";
const PurchaseComponent = loadable(
  () => import("../../components/PurchaseStock/Purchase")
);
type Props = {};

const Purchase = (props: Props) => {
  const { id } = useParams();
  const { isPostLoading, mutateAsync, postData } = usePostHook({
    queryKey: ["purchase-stock"],
    navigateURL: "/purchase-stock",
  });

  const { data: singleProductData, isPending: singleProductLoading } =
    useGetHook({
      queryKey: [`product${id}`],
      url: `${APIS.PRODUCT}${id}/`,
      params: {},
    });

  const handlePurchaseClick = async (values: any) => {
    const url = APIS.PURCHASE;
    const formData = {
      product: id,
      weight: values.weight * values?.quantity,
      reference_number: values?.orderNumber,
      cost_price: values?.costPrice,
      quantity: values?.quantity,
    };
    try {
      const res = await mutateAsync({ url, formData });
    } catch (err) {
      toast.error("Error reconciling stock");
    }
  };
  return (
    <>
      {singleProductLoading ? (
        <Spinner />
      ) : (
        <PurchaseComponent
          handlePurchaseClick={handlePurchaseClick}
          isPostLoading={isPostLoading}
          singleProductData={singleProductData}
        />
      )}
    </>
  );
};

export default Purchase;
